import { ca } from '@cian/analytics';

export function trackMorePromosClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'click_view_more',
    label: 'more',
    useLastProducts: true,
  });
}

export function trackShowPhoneInBannerClick(gaLabel: string) {
  ca('eventSite', {
    action: 'Open_promotions_block',
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackShowPhoneInLayoutsClick(gaLabel: string) {
  ca('eventSite', {
    action: 'Open_layout_modal_block',
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackClickPromosSeoLink() {
  ca('eventSite', {
    action: 'click_block',
    category: 'Promo',
    label: 'seo_url',
    name: 'oldevent',
    useLastProducts: true,
  });
}
